import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Item from './Item';
import { getApps } from '../api/api';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0'
  }
});

class Apps extends Component {

  state = {
    apps: [],
    loading: true
  }

  async componentDidMount() {
    try {
      const response = await getApps();
      const apps = response.items.map(item => ({
        id: item.id,
        image: item.imageUrl,
        link: item.link,
        title: item.description
      }));
      this.setState({ apps, loading: false });
    } catch (err) {
      console.error('Failed to load apps:', err);
      this.setState({ loading: false });
    }
  }

  render() {
    const { classes } = this.props;
    const { apps, loading } = this.state;

    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {apps.map(edu => <Item key={edu.id} section={edu} clickable width={4} type="photo" /> )}
        </Grid>
      </div>
    )
  }
}

Apps.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Apps);
